import UserService from "@/common/user.service.js";
import TokenService from "@/common/token.service.js";
import { ApiService } from "@/common/api.service.js";
const backendUrl = process.env.VUE_APP_BACKEND_URL;

export function logIn(email, password) {
  return ApiService.post(
    backendUrl + "/api/token/",
    { email: email, password: password },
    {},
    false
  ).then(response => {
    UserService.setUser(response.data.user);
    TokenService.setAccessToken(response.data.access);
    TokenService.setRefreshToken(response.data.refresh);
    TokenService.setChatToken(response.data.chat_token);
  });
}
export function passwordReset(email) {
  return ApiService.post(
    backendUrl + "/users/password/reset/",
    { email: email },
    {},
    false
  );
}
export function activateAccount(encoded_pk, activation_key) {
  return ApiService.get(
    backendUrl + "/activate_account/" + encoded_pk + "/" + activation_key + "/",
    {},
    {},
    false
  );
}
export function passwordResetConfirm(access_token, password, confirmPassword) {
  return ApiService.post(
    backendUrl + "/users/password/reset/confirm/",
    { new_password: password, confirm_new_password: confirmPassword },
    { Authorization: "Bearer " + access_token },
    false
  );
}
export function register(firstname, lastname, email, password) {
  return ApiService.post(
    backendUrl + "/users/",
    {
      profile: {
        first_name: firstname,
        last_name: lastname
      },
      email: email,
      password: password
    },
    {},
    false
  );
}
export function refreshChatToken() {
  return ApiService.get(backendUrl + "/api/chat/refresh/").then(response => {
    TokenService.setChatToken(response.data.chat_token);
  });
}
